export const DELETE_TAG_FAILURE = 'DELETE_TAG_FAILURE';

export const deleteTagFailure = (payload: Error) => ({
    type: DELETE_TAG_FAILURE,
    payload,
    error: true,
});
